<section *ngIf="isSpinner || (loaderService?.isLoading | async)">
  <div [class.loading-bar-container]="!isSpinner" [style.transform]="'scale(' + scale + ')'">
    <div
      [class.loading-bar]="!isSpinner"
      [class.spinner]="isSpinner && !isFloorplan"
      [class.loading-floorplan]="isSpinner && isFloorplan"
      class="d-flex flex-nowrap justify-content-between align-items-center">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</section>
